import { render, staticRenderFns } from "./icon-daycare.vue?vue&type=template&id=0d5a6f25&scoped=true"
var script = {}
import style0 from "./icon-daycare.vue?vue&type=style&index=0&id=0d5a6f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5a6f25",
  null
  
)

export default component.exports